<template>
    <div class="login flex-column align-center">
        <div class="login-logo">
            <img class="login-logo-image" src="@/assets/images/login/logo.png" alt="" />
            <p>泉港智慧停车</p>
        </div>
        <div class="login-form">
            <van-form validate-first @submit="onSubmit">
                <van-field class="input" v-model="formdata.phoneNo" placeholder="请输入手机号码" :rules="[{ required: true }, { pattern: /(^1[3456789]\d{9}$)|^$/, message: '手机号码格式错误' }]">
                    <template #left-icon>
                        <div class="left-icon">
                            <img class="login-form-icon" src="@/assets/images/login/phone.png" alt="" />
                        </div>
                    </template>
                </van-field>
                <!-- <van-field v-model="formdata.password" type="password" placeholder="请输入密码" :rules="[{ required: true, message: '请填写密码' }]">
                    <template #left-icon>
                        <img class="login-form-icon" src="@/assets/images/login/password.png" alt="" />
                    </template>
                </van-field> -->

                <van-field v-model="formdata.captchaCode" maxlength="4" :rules="[{ required: true }]" center clearable placeholder="请输入短信验证码">
                    <template #left-icon>
                        <div class="left-icon">
                            <img class="login-form-icon" src="@/assets/images/login/password.png" alt="" />
                        </div>
                    </template>
                    <template #button>
                        <span class="sendCodeBtn" @click="sendCode">{{ sendCodeText }}</span>
                    </template>
                </van-field>
                <!-- <p class="login-form-forgetpsw">忘记密码?</p> -->
                <div style="margin: 53px 0 24px">
                    <van-button round block type="info" class="login-button">登录</van-button>
                </div>
                <p class="login-form-protocol">
                    <van-checkbox icon-size="16" checked-color="#009af3" v-model="checked"> 我已阅读并同意<span @click="skipUserAgreement" style="color: #009af3">《用户协议》</span> 和 <span @click="skipUserAgreement" style="color: #009af3">《隐私政策》</span> </van-checkbox>
                </p>
            </van-form>
        </div>
        <div class="login-footer">
            <!-- <div class="login-footer-wechat flex-column align-center justify-center">
                <img class="login-footer-wechat-image" src="@/assets/images/login/wechat.png" alt="" />
                <p>微信快捷登录</p>
            </div> -->
        </div>
    </div>
</template>

<script>
import { getSmsCode } from "@/api/api";
import { parseSmsKey } from "@/libs/parseData";

import config from "@/config/index";
export default {
    name: "Login",
    data() {
        return {
            formdata: {
                phoneNo: "",
                captchaCode: "",
                code: "",
            },
            checked: false,
            second: 60,
            sendCodeText: "获取验证码",
        };
    },
    mounted() {
        // if (Object.keys(this.$route.query).length == 0) {
        //     window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wechatAuthType.APP_ID}&redirect_uri=${window.location.href}&response_type=code&scope=snsapi_userinfo&state=${1}#wechat_redirect`;
        // }
        // 只有微信授权回调才有query;
        if (Object.keys(this.$route.query).length > 0) {
            localStorage.setItem("wxAuthUrl", window.location.href);
            this.formdata.code = this.$route.query.code;
        }
    },
    methods: {
        //获取公众号openId
        //登录
        onSubmit() {
            // this.$store.commit("setToken", "1d5fad1e-cac1-47c0-8c02-5c937452acb5");
            // this.$store.dispatch("getUserInfo").then((res) => {
            //     this.$router.replace({
            //         path: "/",
            //     });
            // });
            if (!this.checked) {
                this.$toast("请先查看《用户协议》和《隐私政策》");
                return;
            }
            this.$store.dispatch("handleLogin", this.formdata).then((res) => {
                console.log(res);
                this.$store.dispatch("getUserInfo").then((res) => {
                    this.$router.replace({
                        path: "/",
                    });
                });
            });
        },

        //用户协议
        skipUserAgreement() {
            this.$router.push({
                path: "/login/userAgreement",
            });
        },
        //发送验证码
        sendCode() {
            if (!/(^1[3456789]\d{9}$)|^$/.test(this.formdata.phoneNo)) {
                this.$toast("手机号码格式错误");
                return;
            }
            if (this.second == 60) {
                let params = {
                    accessKey: config.accessKey,
                    accessToken: parseSmsKey(this.formdata.phoneNo),
                    phoneNo: this.formdata.phoneNo,
                };
                sendSmsApi(params).then((res) => {
                    this.timer = setInterval(() => {
                        if (this.second > 0) {
                            this.second -= 1;
                            this.sendCodeText = this.second + "s后重新获取";
                        } else {
                            this.sendCodeText = "获取验证码";
                            this.second = 60;
                            clearInterval(this.timer);
                        }
                    }, 1000);
                    this.$notify({
                        message: "验证码已发送，请注意查收",
                        color: "#009AF3",
                        background: "#D3E8FB",
                    });
                });
            } else {
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/color.less";

.login-button {
    background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
}
.sendCodeBtn {
    color: @main-color;
    font-size: 28px;
}
.login {
    height: 100vh;

    .login-logo {
        margin-top: 70px;
        text-align: center;
        .login-logo-image {
            width: 144px;
            height: 144px;
        }

        p {
            color: #666666;
            font-size: 34px;
            font-weight: bold;
        }
    }
    .login-form {
        width: 100%;
        padding: 0 70px;
        .input {
            // border-bottom: 1px red solid;
            // background-color: #f5f8fa;
        }

        margin-top: 106px;
        .left-icon {
            height: 100%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .login-form-icon {
            width: 32px;
            height: 40px;
        }
        .login-form-forgetpsw {
            color: #333;

            font-size: 22px;
            text-align: right;
            margin-top: 10px;
        }
        .login-form-protocol {
            font-size: 22px;
            font-weight: 400;
            color: #999999;
            display: flex;
            justify-content: center;
        }
    }
    .login-footer {
        width: 100vw;
        height: 552px;
        margin-top: auto;
        background: url("~@/assets/images/login/loginbg.png") no-repeat;
        background-size: 100% 100%;
        position: relative;

        .login-footer-wechat {
            position: absolute;
            top: -73px;
            width: 100%;

            .login-footer-wechat-image {
                width: 104px;
                height: 104px;
                margin-bottom: 16px;
            }

            p {
                color: #666;
                font-size: 24px;
            }
        }
    }
}
</style>
